import { authRoles } from 'app/auth';
import i18next from 'i18next';

import UnitOptimizerLogEditForm from './editform/UnitOptimizerLogEditForm';
import UnitOptimizerLogTable from './table/UnitOptimizerLogTable';

import en from './i18n/en';
import hu from './i18n/hu';

i18next.addResourceBundle('en', 'unitOptimizerLog', en);
i18next.addResourceBundle('hu', 'unitOptimizerLog', hu);

export default [
	{
		path: '/unit-optimizer-log/edit/:id/:tabKey?',
		component: UnitOptimizerLogEditForm,
		auth: authRoles.unitOptimizerLog
	},
	{
		path: '/unit-optimizer-log/:sessionNameParam?',
		component: UnitOptimizerLogTable,
		auth: authRoles.unitOptimizerLog
	}
];